"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var singleMetricCard_styles_1 = require("./singleMetricCard.styles");
function SingleMetricCard(props) {
    return (React.createElement("div", { id: props.id, className: singleMetricCard_styles_1.container },
        React.createElement("div", { className: singleMetricCard_styles_1.content },
            React.createElement("div", { id: props.id + "-value", className: singleMetricCard_styles_1.value }, props.value),
            React.createElement("div", { "data-qa": "key", className: singleMetricCard_styles_1.title }, props.title))));
}
exports.SingleMetricCard = SingleMetricCard;
